import Cookies from 'js-cookie'

import { getIsAppDemo } from '../functions'
import { PRODUCTION_DEMO_HOSTS } from '../constants/hosting'
import { validateToken } from './validateToken'

export const userFriendlyJPBouvetMethodUrl = 'jpbouvetmethod.com'
export const JPBouvetMethodUrl = `https://${userFriendlyJPBouvetMethodUrl}`
export const isPayingStudentLocalStorageKey = 'isPayingStudentAccessingDemoDate'

export const getIsPayingStudentAccessingDemo = async () => {
	const isAppDemo = getIsAppDemo()
	if (!isAppDemo) {
		return false
	}

	const currentDate = new Date()

	const localStoredDate = localStorage.getItem(isPayingStudentLocalStorageKey)
	if (localStoredDate) {
		const storedValueAsDate = new Date(localStoredDate)
		const oneWeekLater = new Date(storedValueAsDate).setDate(storedValueAsDate.getDate() + 7)

		// In this case there has been a paying student accessing the demo on this browser at some point.
		// Therefore we should automatically provide access to the legacy web appif it is within one week of the stored date
		if (currentDate <= oneWeekLater) {
			return true
		}
	}

	// If the user does not have existing token access we should check the token
	const token = Cookies.get('token')
	if (!token) {
		// If there is no token, we should not consider the user a paying student
		return false
	}

	const isPayingStudentAccessingDemo = await validateToken(token)
	if (isPayingStudentAccessingDemo) {
		// Save the fact that this is a paying student in localStorage
		localStorage.setItem(isPayingStudentLocalStorageKey, currentDate.toISOString())
	} else {
		// If the token is invalid, remove the localStorage item
		localStorage.removeItem(isPayingStudentLocalStorageKey)
	}

	return isPayingStudentAccessingDemo
}

export const getIsPayingStudentAccessingCourseMaterial = async () => {
	const isPayingStudentAccessingDemo = await getIsPayingStudentAccessingDemo()
	if (!isPayingStudentAccessingDemo) {
		return false
	}

	// We should only check the token if the user is accessing the demo at the expected host
	// and if there are query parameters in the URL - this means the user is likely
	// & if they are on a desktop device that would not benefit from the app experience
	// & if they are accessing course material from jpbouvetmethod.com
	const currentHost = window.location.hostname
	const hasQueryParams = new URLSearchParams(window.location.search).toString() !== ''
	const shouldConsiderLegacyWebAppAccess = PRODUCTION_DEMO_HOSTS.includes(currentHost) && hasQueryParams

	return shouldConsiderLegacyWebAppAccess
}
